import { render } from "./PosAccount.vue?vue&type=template&id=18cfc44c"
import script from "./PosAccount.vue?vue&type=script&lang=js"
export * from "./PosAccount.vue?vue&type=script&lang=js"

import "./PosAccount.vue?vue&type=style&index=0&id=18cfc44c&lang=css"
import "./PosAccount.vue?vue&type=style&index=1&id=18cfc44c&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__